import { NOMINEE } from '../../../../redux-store/types/nct';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { emailRegex, mobileRegex } from '../../../../utils/constants';
import { Nominee } from '../../commercial/ExploreMFs/types';
import { NOMINEEINFO } from './update-nominee-edit';

export interface NomineeInfoRowData {
    amc?: string;
    amcName: string;
    id: string | number;
    mobile?: string;
    investorName?: string;
    nominees: NOMINEE[];
    assetType?: string[];
    taxStatusLabel: string;
}

export const getPinCode = (ele: NOMINEEINFO, isKfin: boolean, address: any) => {
    if (isKfin) {
        if (ele.addressSameAsFH === 'Y') {
            if (address?.country !== 'India') {
                return 0;
            }
            return address?.pincode;
        }
        if (ele.country !== 'India') {
            return 0;
        }
        return ele.pincode;
    } else {
        return ele.addressSameAsFH === 'Y' ? 0 : ele.pincode;
    }
};

export const checkRequiredFields = (nomineeDetails: NOMINEEINFO | Nominee) => {
    if (!nomineeDetails.address1) {
        throw Error('Address 1 is required, Please uncheck the "Address same as FH" checkbox');
    }
    if (!emailRegex.test(nomineeDetails.email || '')) {
        throw Error('Invalid email');
    }
    if (!mobileRegex.test(nomineeDetails.mobile || '')) {
        throw Error('Invalid mobile number');
    }
    // if (!nomineeDetails.pan) {
    //     throw Error('PAN is required');
    // }
    if (!nomineeDetails.docName) {
        throw Error(
            'IdentityType must be one of the following values: AADHAR, PAN, DRIVING LICENSE, PASSPORT',
        );
    }
    if (!nomineeDetails.docValue) {
        throw Error('Identity number is required');
    }
    if (!nomineeDetails.city) {
        throw Error(
            'City must be longer than or equal to 1 characters, Please uncheck the "Address same as FH" checkbox',
        );
    }
    if (!nomineeDetails.state) {
        throw Error(
            'State must be longer than or equal to 1 characters, Please uncheck the "Address same as FH" checkbox',
        );
    }
    if (!nomineeDetails.country) {
        throw Error(
            'Country must be longer than or equal to 1 characters, Please uncheck the "Address same as FH" checkbox',
        );
    }
    if (nomineeDetails.country === 'India') {
        if (!nomineeDetails.pincode) {
            throw Error(
                'Pincode must be longer than or equal to 1 characters, Please uncheck the "Address same as FH" checkbox',
            );
        }
        if (nomineeDetails.pincode.toString().length !== 6) {
            throw Error('Pincode must be 6 digits');
        }
    }
    if (nomineeDetails.country !== 'India') {
        const nonIndiaPincodeRegex = /^[A-Za-z0-9]+$/;
        if (!nonIndiaPincodeRegex.test(nomineeDetails.pincode.toString())) {
            throw Error('Pincode must be alphanumeric');
        }
        if (nomineeDetails.pincode.toString().length > 20) {
            throw Error('Pincode must be less than or equal to 20 characters');
        }
    }
    // if (!nomineeDetails!nomineeDetails.pincode) {
    //     throw Error(
    //         'Pincode must be longer than or equal to 1 characters, Please uncheck the "Address same as FH" checkbox',
    //     );
    // }
};
